import { render, staticRenderFns } from "./DeleteHeader.vue?vue&type=template&id=203416cc"
import script from "./DeleteHeader.vue?vue&type=script&lang=js"
export * from "./DeleteHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports